"use strict";
exports.__esModule = true;
exports.parse = void 0;
var pointFactory_1 = require("../pointFactory");
var POINT_REGEX = /SRID=((EPSG:)?(\w+));POINT\((-?\d+(\.\d+)?) (-?\d+(\.\d+)?)\)/;
var parse = function (pointText) {
    var match = POINT_REGEX.exec(pointText);
    if (!match)
        return null;
    var srs = match[3];
    var x = Number(match[4]);
    var y = Number(match[6]);
    return pointFactory_1.PointFactory.createInstance({ srs: srs, x: x, y: y });
};
exports.parse = parse;
//# sourceMappingURL=parse.js.map